import { categoryActionTypes } from '@Actions/categoryActions';

const CategoryReducers = (state = { }, action) => {
  switch (action.type) {
  case categoryActionTypes.CREATE_CATEGORY.LOADING: {
    const { createCategoryLoading } = action;
    return {
      ...state,
      createCategoryLoading,
    };
  }
  case categoryActionTypes.GET_CATEGORIES.LOADING: {
    const { getCategoriesLoading } = action;
    return {
      ...state,
      getCategoriesLoading,
    };
  }
  case categoryActionTypes.GET_CATEGORIES.SUCCESS: {
    const { categories } = action;
    return {
      ...state,
      categories,
    };
  }
  case categoryActionTypes.UPDATE_CATEGORY.LOADING: {
    const { updateCategoryLoading } = action;
    return {
      ...state,
      updateCategoryLoading,
    };
  }
  case categoryActionTypes.DELETE_CATEGORY.LOADING: {
    const { deleteCategoryLoading } = action;
    return {
      ...state,
      deleteCategoryLoading,
    };
  }

  // create sub category
  case categoryActionTypes.CREATE_SUB_CATEGORY.LOADING: {
    const { createSubCategoryLoading } = action;
    return {
      ...state,
      createSubCategoryLoading,
    };
  }

  // get sub category
  case categoryActionTypes.GET_SUB_CATEGORIES.LOADING: {
    const { getSubCategoriesLoading } = action;
    return {
      ...state,
      getSubCategoriesLoading,
    };
  }
  case categoryActionTypes.GET_SUB_CATEGORIES.SUCCESS: {
    const { subCategories } = action;
    return {
      ...state,
      subCategories,
    };
  }

  default: {
    return state;
  }
  }
};

export default CategoryReducers;
